var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('b-row',[_c('b-col',{attrs:{"md":"12"}},[_c('span',{staticClass:"text-main-color f-size-16 font-weight-bold mb-1"},[_vm._v("Images")])]),_c('b-col',{attrs:{"md":"12"}},[_c('ImageListUpload',{staticClass:"mt-1",attrs:{"v":_vm.v,"dataList":_vm.dataList},on:{"handleChangeImageList":_vm.handleChangeImageList}})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }